import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {
    private socket!: WebSocket;
    private messages = new Subject<any>();
    private baseUrl = 'https://notificaciones.unexa.ar';

    constructor(
        private ngZone: NgZone,
        private _httpClient: HttpClient,
    ) {}

    connect(token: string): Observable<any> {
        const url = `wss://notificaciones.unexa.ar/stream?token=${token}`;
        this.socket = new WebSocket(url);

        this.socket.onopen = () => console.log('🔌 Conectado a Gotify WebSocket');
        this.socket.onerror = err => console.error('❌ Error WebSocket:', err);
        this.socket.onclose = () => console.log('🔒 Conexión cerrada');

        this.socket.onmessage = event => {
        const data = JSON.parse(event.data);
        // Angular no detecta cambios fuera de NgZone
        this.ngZone.run(() => this.messages.next(data));
        };

        return this.messages.asObservable();
    }

    disconnect() {
        console.log('DISCONNECT');

        if (this.socket) this.socket.close();
    }

    getMessages(token: string): Observable<any> {
        return this._httpClient.get(`${this.baseUrl}/message?token=${token}`);
    }

    getServersStatus(): Observable<any> {
        return this._httpClient.get(`https://uptime.puntosalud.ar/api/status-page/servicios/badge`, {responseType: 'text'});
    }
}
